//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.NCGroupBuilder.js";
import "../CAM/CAM.InheritableIntBuilder.js";
import "../CAM/CAM.LayoutCiBuilder.js";
import "../CAM/CAM.ToolAxisFilterBuilder.js";
let d=[[[1,"FixtureOffsetBuilder",0,"CAM.InheritableIntBuilder",0],[1,"LayoutCiBuilder",0,"CAM.LayoutCiBuilder",0],[0,"LinkRcsToMcs",1,0],[0,"Mcs",1,"CartesianCoordinateSystem",0],[0,"McsLocationMode",1,0],[0,"McsWorkpiece",1,"NXObject",0],[0,"Rcs",1,"CartesianCoordinateSystem",0],[1,"ToolAxisFilterBuilder",0,"CAM.ToolAxisFilterBuilder",0],[0,"ToolAxisVector",1,"NXObject",0]],[[[],"GetCsysPurposeMode",{R_:{csysPurposeMode:''}},0,0],[["csysPurposeMode"],"SetCsysPurposeMode",{},1,0],[[],"GetSpecialOutputMode",{R_:{specialOutputMode:''}},0,0],[["specialOutputMode"],"SetSpecialOutputMode",{},1,0],[[],"GetToolAxisMode",{R_:{toolAxisMode:''}},0,0],[["toolAxisMode"],"SetToolAxisMode",{},1,0],[["zeroFace","zeroPosition"],"SetBlockMcsOrigin",{},2,0],[["zeroFace"],"SetCylinderMcsOrigin",{},1,0]],[]];
SPLM.CAM.OrientGeomBuilder = class extends SPLM.CAM.NCGroupBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.OrientGeomBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.OrientGeomBuilder.CsysPurposeModes = Object.freeze({
    "Local" : "Local", "Main" : "Main"});

SPLM.CAM.OrientGeomBuilder.SpecialOutputModes = Object.freeze({
    "None" : "None", "UseMainMcs" : "UseMainMcs", "FixtureOffset" : "FixtureOffset", "CsysRotation" : "CsysRotation", "UseInheritedMcs" : "UseInheritedMcs"});

SPLM.CAM.OrientGeomBuilder.ToolAxisModes = Object.freeze({
    "PositiveZOfMcs" : "PositiveZOfMcs", "FixedAxis" : "FixedAxis", "AllAxes" : "AllAxes"});

SPLM.CAM.OrientGeomBuilder.McsLocationModes = Object.freeze({
    "Specify" : "Specify", "OnBlank" : "OnBlank", "OnPartBox" : "OnPartBox"});

SPLM.CAM.OrientGeomBuilder.McsZeroFace = Object.freeze({
    "Bottom" : "Bottom", "Middle" : "Middle", "Top" : "Top"});

SPLM.CAM.OrientGeomBuilder.McsZeroPosition = Object.freeze({
    "Center" : "Center", "North" : "North", "NorthEast" : "NorthEast", "East" : "East", "SouthEast" : "SouthEast", "South" : "South", "SouthWest" : "SouthWest", "West" : "West", "NorthWest" : "NorthWest"});

export default SPLM;